module.exports = __webpack_public_path__ + "img/dianliu0.gif";